// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/scrollbar.css';


// Suppress browser extension listener errors
window.addEventListener('error', (event) => {
  if (event.message.includes('A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received')) {
    event.preventDefault();
    return false;
  }
});

// Suppress unhandled promise rejections from browser extensions
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason.message === 'string' && 
      event.reason.message.includes('message channel closed')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);  